// src/components/Footer.js
import { Link, useNavigate } from "react-router-dom";
import { FaFacebook, FaTwitter, FaLinkedin, FaTelegram } from "react-icons/fa";

// Define TrendingUp icon within the file
const TrendingUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

export default function Footer() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="relative z-10 py-12 px-4 md:px-6 lg:px-8 border-t border-slate-800 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <h3 className="font-bold mb-4 text-lg">Algosoftware</h3>
          <p className="text-sm text-slate-400 mb-4">
            Revolutionizing copy trading in the share market
          </p>
          <div className="flex space-x-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-xl text-slate-400 hover:text-blue-400" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="text-xl text-slate-400 hover:text-blue-400" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-xl text-slate-400 hover:text-blue-400" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-bold mb-4 text-lg">Legal</h3>
          <ul className="space-y-2 text-sm">
            {[
             { to: "/terms-of-service", label: "Terms of service" },
             
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-slate-400 hover:text-white"
                  onClick={() => handleNavigation(item.to)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

        </div>

        <div>
          <h3 className="font-bold mb-4 text-lg">Resources</h3>
          <ul className="space-y-2 text-sm">
            {[
              { to: "#1", label: "Guides" },
              { to: "#2", label: "Blog" },
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-slate-400 hover:text-white"
                  onClick={() => handleNavigation(item.to)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-bold mb-4 text-lg">Company</h3>
          <ul className="space-y-2 text-sm">
            {[
              { to: "/about-us", label: "About" },
              // { to: "/careers", label: "Careers" },
              { to: "/contact", label: "Contact" },
            ].map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-slate-400 hover:text-white"
                  onClick={() => handleNavigation(item.to)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-4">
            <p className="text-sm text-slate-400">Developer: Nathan Spencer</p>
            <p className="text-sm text-slate-400">Email: nathanspencer673@gmail.com</p>
            <div className="flex space-x-4 mt-2">
              <a
                href="https://www.linkedin.com/in/nitish-kumar-bscit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-xl text-slate-400 hover:text-blue-400" />
              </a>
              <a href="https://t.me/Nathanspencer" target="_blank" rel="noopener noreferrer">
                <FaTelegram className="text-xl text-slate-400 hover:text-blue-400" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center">
        <Link
          to="/"
          className="flex items-center gap-2 text-xl font-bold mb-4 md:mb-0"
          onClick={() => handleNavigation("/")}
        >
          <span className="text-blue-500">
            <TrendingUp />
          </span>
          <span>AlgoSoftware</span>
        </Link>
        <p className="text-sm text-slate-400">
          © {new Date().getFullYear()} AlgoSoftware, Inc. All rights reserved.
        </p>
      </div>
    </footer>
  );
}